export const state = {
  loader: false,
};

export const mutations = {
  SET_LOADER(state, loader) {
    state.loader = loader;
  },
};
